import { render } from "./ColorpickerCore.vue?vue&type=template&id=fb66fbd4"
import script from "./ColorpickerCore.vue?vue&type=script&lang=js"
export * from "./ColorpickerCore.vue?vue&type=script&lang=js"

import "./ColorpickerCore.vue?vue&type=style&index=0&id=fb66fbd4&lang=css"
script.render = render

export default script